import { createSelector } from "reselect";
import { filesAdapter } from "./Slice";
const filesSlice = (state) => state.patientFiles;
export const filesByTypeSelector = (state, photoType) => createSelector(filesAdapter.getSelectors(filesSlice).selectAll, (files) => files.filter((file) => file.filesType === photoType))(state);
export const filesByTypesSelector = (state, photoTypes) => createSelector(filesAdapter.getSelectors(filesSlice).selectAll, (files) => files.filter((file) => photoTypes.includes(file.filesType)))(state);
